import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useAnalytics } from '@provider-directory/components/analytics/analytics-provider';
import { useOrgContext } from '@provider-directory/components/org-context/org-context-provider';

export interface LinkProps {
  href: string;
  text: string;
  analyticsText: string;
  className?: string;
}

export const FooterLink: React.FC<LinkProps> = ({
  href,
  text,
  analyticsText,
  className,
}) => {
  const { key } = useOrgContext();
  const { t } = useTranslation(key);
  const analytics = useAnalytics();
  return (
    <a
      className={clsx(
        'mf-link mf-link--site-montefiore mf-link--primary mf-link--base mf-link--no-underline',
        className,
      )}
      onClick={() => {
        analytics.navigationClickEvent({
          navigationType: 'footer',
          clickText: analyticsText,
          linkType: 'link',
        });
      }}
      href={href}
      data-analytics-click-text={analyticsText}
      data-analytics-link-type={'link'}
    >
      <span className={'mf-link__text'}>
        <span className={'mf-link__text__inner'}>{t(text)}</span>
      </span>
    </a>
  );
};
